import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { I18nPipeModule } from '../../../pipes/i18n-pipe.module';
import { AvailabilityShiftToggleListComponent } from './availability-shift-toggle-list.component';
import { EnumToArrayPipeModule } from '../enum-to-array-pipe/enum-to-array-pipe.module';
import { ToggleButtonsModule } from '../toggle-buttons/toggle-buttons.module';

@NgModule({
  declarations: [AvailabilityShiftToggleListComponent],
  imports: [
    CommonModule,
    I18nPipeModule,
    EnumToArrayPipeModule,
    ToggleButtonsModule,
  ],
  exports: [AvailabilityShiftToggleListComponent],
})
export class AvailabilityShiftToggleListModule {}
